<template>
  <div class="w-full">
    <AppPriceCard
      :class="`border border-${selectedSubscription?.colorHeaderBg} rounded-[10px]`"
      :color-header-bg="selectedSubscription?.colorHeaderBg ?? ''"
      :color-header-txt="selectedSubscription?.colorHeaderTxt ?? ''"
      :features="selectedSubscription?.features ?? undefined"
      :feature-text="selectedSubscription?.featureText ?? undefined"
      :hide-button="true"
      :text-cta="selectedSubscription?.textCta ?? ''"
      :price="selectedSubscription?.price ?? ''"
      :price-condition="selectedSubscription?.priceCondition"
      :price-interval="selectedSubscription?.priceInterval ?? ''"
      :price-info="selectedSubscription?.priceInfo ?? ''"
      :price-text="selectedSubscription?.priceText ?? ''"
      :price-sub-text="selectedSubscription?.priceSubText ?? ''"
      :tier="(selectedSubscription?.tier as TierLevel)"
    />
    <!-- <div class="mt-4 text-center text-regular-14">* zzgl. MwSt</div> -->
  </div>
</template>

<script setup lang="ts">
import type { TierLevel } from '~/enum/tier-level.enum';

const { t } = useI18n();

const isProd = useRuntimeConfig().public.isProd;
const props = defineProps<{ selectedpriceId: string }>();

const cards = [
  {
    colorHeaderBg: 'iq-beige',
    colorHeaderTxt: 'iq-black',
    features: [
      { label: t('subscriptions.basic.feature1'), isIncluded: true },
      { label: t('subscriptions.basic.feature2'), isIncluded: true },
      { label: t('subscriptions.basic.feature3'), isIncluded: true },
      { label: t('subscriptions.basic.feature4'), isIncluded: true },
      { label: t('subscriptions.basic.feature5'), isIncluded: true },
    ],
    textCta: t('cta.buy'),
    price: '29€',
    priceInterval: t('cta.month'),
    priceId: isProd
      ? 'price_1OsuiiD8yuHin9TUalbQVCv7'
      : 'price_1OlU1ND8yuHin9TUdpTNpFQI',
    priceInfo: t('priceInfo.basic'),
    priceCondition: t('cta.monthlyCancellable'),
    tier: 'BASIC',
  },
  {
    colorHeaderBg: 'iq-red',
    colorHeaderTxt: 'white',
    features: [
      { label: t('subscriptions.pro.feature1'), isIncluded: true },
      { label: t('subscriptions.pro.feature2'), isIncluded: true },
      { label: t('subscriptions.pro.feature3'), isIncluded: true },
      { label: t('subscriptions.pro.feature4'), isIncluded: true },
      { label: t('subscriptions.pro.feature5'), isIncluded: true },
    ],
    textCta: t('cta.buy'),
    price: '85€',
    priceInterval: t('cta.month'),
    priceId: isProd
      ? 'price_1OsuimD8yuHin9TUyJu0QK4q'
      : 'price_1OlU2mD8yuHin9TU3w7RM0rg',
    priceInfo: t('priceInfo.basic'),
    priceCondition: t('cta.monthlyCancellable'),
    tier: 'PRO',
  },
  {
    colorHeaderBg: 'iq-beige',
    colorHeaderTxt: 'iq-black',
    featureText: t('cta.enterpriseFeatureText'),
    textCta: t('cta.request'),
    title: '€48*',
    priceText: t('cta.individual'),
    priceSubText: t('cta.offer'),
    tier: 'ENTERPRISE',
  },
];

const selectedSubscription = computed(() =>
  cards.find((c) => c.priceId === props.selectedpriceId)
);
</script>

<i18n lang="json">
{
  "de": {
    "subscriptions": {
      "basic": {
        "feature1": "15 Zielkunden Scans/Monat",
        "feature2": "Analyse Zielkundenprofil",
        "feature3": "Analyse Zielkundennutzen",
        "feature4": "Zielgerichtetes Anschreiben",
        "feature5": "20 Scanprofile"
      },
      "pro": {
        "feature1": "50 Zielkunden Scans /Monat",
        "feature2": "Analyse Zielkundenprofil",
        "feature3": "Analyse Zielkundennutzen",
        "feature4": "Zielgerichtetes Anschreiben",
        "feature5": "100 Scanprofile"
      }
    },
    "cta": {
      "buy": "kaufen",
      "month": "Monat*",
      "monthlyCancellable": "monatlich kündbar",
      "request": "Anfragen",
      "individual": "individuelles",
      "offer": "Angebot",
      "enterpriseFeatureText": "Wenn du einen erhöhten Bedarf hast oder ergänzende Leistungen wünschst, sprich uns gerne an."
    },
    "priceInfo": {
      "basic": "Ergänzung: Zielkunden Scans </br> ab 1,70 € / Scan*",
      "pro": "Ergänzung: Zielkunden Scans </br> ab 1,50 €  / Scan*"
    },
    "taxNotice": "* zzgl. MwSt"
  },
  "en": {
    "subscriptions": {
      "basic": {
        "feature1": "15 target customer scans/month",
        "feature2": "Target customer profile analysis",
        "feature3": "Target customer benefit analysis",
        "feature4": "Targeted cover letter",
        "feature5": "20 scan profiles"
      },
      "pro": {
        "feature1": "50 target customer scans/month",
        "feature2": "Target customer profile analysis",
        "feature3": "Target customer benefit analysis",
        "feature4": "Targeted cover letter",
        "feature5": "100 scan profiles"
      }
    },
    "cta": {
      "buy": "buy",
      "month": "month*",
      "monthlyCancellable": "can be canceled monthly",
      "request": "request",
      "individual": "individual",
      "offer": "offer",
      "enterpriseFeatureText": "If you have increased needs or want additional services, please contact us."
    },
    "priceInfo": {
      "basic": "Supplement: Target customer scans </br> from €1.70 / scan*",
      "pro": "Supplement: Target customer scans </br> from €1.50 / scan*"
    },
    "taxNotice": "* plus VAT"
  }
}
</i18n>
